<template>
    <div id="storefront" class="content">
        <div class="container">
            <h1 class="mb-5">
                Storefront Setting
            </h1>
            <nav-storefront tab="theme"></nav-storefront>

            <card-box>
                <card-title class="mb-3">Footer</card-title>

                <editor :init="customToolbar" id="footer" ref="footerEditor" :key="editorKey"
                        api-key="gdhlyynmp3tt3gvuf2g7z30zs6dba2kuo60nk82wfm3pf7rn"
                        v-model="page.footer.detail"></editor>

                <button @click="getTemplate('footer')" class="mt-3 float-right btn btn-outline-secondary">Created
                    from template
                </button>
                <button @click="updatePage('footer')" class="mt-3 btn btn-success">Save</button>
            </card-box>

            <card-box>
                <card-title class="mb-3">CSS</card-title>

                <prism-editor class="border" :autoStyleLineNumbers="true" :lineNumbers="true" style="height: 500px"
                              v-model="page.css.detail" language="css"></prism-editor>


                <button @click="updatePage('css')" class="mt-3 btn btn-success">Save</button>
            </card-box>


        </div>
    </div>
</template>

<script>
    import CardTitle from "@/components/CardTitle";
    import CardBox from "@/components/CardBox";
    import NavStorefront from "../components/NavStorefront";
    import Editor from '@tinymce/tinymce-vue';
    import PrismEditor from 'vue-prism-editor'

    export default {
        name: "StoreTheme",
        components: {NavStorefront, Editor, CardBox, CardTitle, PrismEditor},
        data: function () {
            return {
                enableEditor: true,
                customToolbar: {
                    height: 500,
                    menubar: true,
                    content_css: null,
                    plugins: [
                        'advlist autolink lists link image charmap print preview anchor textcolor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount'
                    ],
                    toolbar: 'undo redo | formatselect | bold italic forecolor  image  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat code '
                },

                page: {
                    footer: {detail: ''},
                    css: {detail: ''}
                },
                css: '',
                editorKey: 0

            }
        },
        methods: {
            getCss: async function () {
                let vm = this
                this.$http.get(this.$config.api + 'css').then(function (res) {
                    vm.customToolbar.content_css = res.data.join(',')
                    vm.editorKey = vm.editorKey + 1
                });
            },
            getPage: function (slug) {
                let vm = this
                this.$http.get(this.$config.api + 'page/' + slug).then(function (res) {
                    //    console.log(res.data)
                    vm.page[slug] = res.data

                });
            },
            getTemplate: function (slug) {
                let vm = this
                let name = this.page[slug].name

                this.$swal({
                    title: 'Create from template?',
                    text: 'Your current ' + name + ' will be replaced with template content.',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Replace it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        this.$http.get(this.$config.api + 'page/template/' + slug).then(function (res) {
                            //  let name = slug.charAt(0).toUpperCase() + slug.slice(1)
                            vm.page[slug].detail = res.data.content
                            vm.editorKey++
                        });
                    }
                })


            },
            updatePage: function (slug) {
                let vm = this
                let post = {'detail': vm.page[slug].detail, 'slug': slug}
                let name = this.page[slug].name

                this.$http.post(this.$config.api + 'page', post).then(function () {
                    vm.$swal(name + ' page saved')
                    if (slug == 'css') {
                        vm.editorKey++
                    }
                });
            }
        },


        mounted: async function () {
            this.$store.commit('ACTIVE_SIDEBAR', 'store')
            await this.getCss()
            this.getPage('footer')
            this.getPage('css')

        }


    }
</script>

<style scoped lang="scss">

</style>